import { computed } from '@angular/core';
import {
  patchState,
  signalStore,
  withComputed,
  withMethods,
  withState,
} from '@ngrx/signals';

import { IMembership } from '@models/IMembership';

const initialState: {
  memberships: IMembership[];
  membershipsById: Map<string, IMembership>;
  loading: boolean;
  error: string | null;
} = {
  memberships: [],
  membershipsById: new Map<string, IMembership>(),
  // the idea is use just this one Later instead of any other --- IGNORE ---
  loading: false,
  error: null,
};

export const MembershipStore = signalStore(
  withState(initialState),
  withComputed((store) => ({
    membershipsCount: computed(() => store.membershipsById().size),
  })),
  withMethods((store) => ({
    setMembershipsById: (memberships: IMembership[]) => {
      const membershipsById = new Map<string, IMembership>();
      const allMemberships = [...store.memberships(), ...memberships];

      allMemberships.forEach((membership) => {
        membershipsById.set(membership.id || '', membership);
      });

      patchState(store, (prev) => ({
        ...prev,
        memberships: Array.from(membershipsById.values()),
        membershipsById,
        error: null,
      }));
    },

    setMemberships: (memberships: IMembership[]) => {
      patchState(store, (prev) => ({
        ...prev,
        memberships,
        error: null,
      }));
    },
    deleteMembership: (membershipId: string) => {
      patchState(store, (prev) => {
        const membershipsById = new Map(store.membershipsById());
        membershipsById.delete(membershipId);
        return {
          ...prev,
          membershipsById,
        };
      });
    },

    setLoading: (loading: boolean) => {
      patchState(store, (store) => ({
        ...store,
        loading,
      }));
    },
    setError: (error: string | null) => {
      patchState(store, (store) => ({
        ...store,
        error,
      }));
    },
  })),
);
